import {injectable} from "inversify";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {Observable} from "rxjs";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";
import {InternalChatMessageEntity} from "@dropDesk/domain/entities/internal_chat/messages/internal_chat_message_entity";
import {InternalChatListFilters} from "@dropDesk/domain/entities/internal_chat/internal_chat_list_filters";
import {InternalChatUsersListFilters} from "@dropDesk/domain/entities/internal_chat/internal_chat_users_list_filters";
import {InternalChatUserEntity} from "@dropDesk/domain/entities/internal_chat/users/internal_chat_user_entity";
import {CancelTokenSource} from "axios";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";

@injectable()
export abstract class InternalChatRepository {
    public abstract listInternalChats(filters: InternalChatListFilters): Promise<ListPaginationEntity<InternalChatEntity>>;

    public abstract subscribe(): Observable<InternalChatEntity[]>;

    public abstract loadMessages(internalChatId: string, page: number, cancelTokenSource?: CancelTokenSource): Promise<ListPaginationEntity<InternalChatMessageEntity>>;

    public abstract sendMessage(message: InternalChatMessageEntity): Promise<InternalChatMessageEntity>;

    public abstract deleteMessage(id: string): Promise<void>;

    public abstract editMessage(idMessage: string, text: string): Promise<void>;

    public abstract informReadMessages(internalChatId: string, cancelTokenSource?: CancelTokenSource): Promise<void>;

    public abstract clearInternalChatsCache(): void;

    public abstract getInternalChatFromCache(id: string): InternalChatEntity | undefined;

    public abstract updateCacheFromSingleInternalChat(internalChat: InternalChatEntity): void;

    public abstract set(internalChat: InternalChatEntity): Promise<InternalChatEntity>;

    public abstract changeDescription(id: string, description: string): Promise<InternalChatEntity>;

    public abstract delete(id: string): Promise<void>;

    public abstract listUsers(filters: InternalChatUsersListFilters): Promise<ListPaginationEntity<InternalChatUserEntity>>;

    public abstract changeUsers(id: string, users: InternalChatUserEntity[]): Promise<InternalChatEntity>;

    public abstract subscriptionUploadFile(message: InternalChatMessageEntity): Observable<InternalChatMessageEntity>;

    public abstract navigateToMessage(id: string, idInternalChat: string): Promise<ListPaginationEntity<InternalChatMessageEntity>>;

    public abstract reactMessage(messageId: string, reactionId: string, reaction: string): Promise<void>;

    public abstract getUsersFromCache(ids: string[]): Promise<UserEntity[]>;

    public abstract getMessageById(id: string): Promise<InternalChatMessageEntity>;
}
